module.exports = __webpack_public_path__ + "img/question.df834413.svg";